import React from "react";
import { Card, Tabs, Typography } from "antd";
import ListAllLetters from "../../../components/Manage/Letters/ListAllLetters";
import LetterHeader from "../../../components/Manage/Letters/LetterHeader";
import DigitalSign from "../../../components/Manage/Letters/DigitalSign";
import TandC from "../../../components/Manage/Letters/T&C/TandC";
import CompanyLocation from "../../../components/Manage/Letters/Footer/CompanyLocation";
import ManageTC from "../../../components/Manage/Letters/T&C/ManageTC";

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const items = [
  {
    key: "1",
    label: "Letter Header",
    children: <LetterHeader />,
  },
  {
    key: "2",
    label: "Digital Signature",
    children: <DigitalSign />,
  },
  {
    key: "3",
    label: "Company Locations",
    children: <CompanyLocation />,
  },
  {
    key: "4",
    label: "Terms & Conditions",
    children: <ManageTC />,
  },
];

const ManageLetters = () => {
  const perm = getPermission('/manage-letter-formats');

  if (!perm.read) {
    return (
      <Card size="large" title="Manage Letters">
        <Typography.Text type="secondary">You don't have permission to view this page.</Typography.Text>
      </Card>
    );
  }

  return (
    <Card size="large" title="Manage Letters">
      <Tabs
        tabPosition="left"
        size="large"
        defaultActiveKey="1"
        items={items}
      />
    </Card>
  );
};

export default ManageLetters;
